module.exports = __webpack_public_path__ + "assets/img/log.e77d9fe4.jpg";